import { apiClients } from '../config/apiClient';
import axios from 'axios';

export const pricingAPI = {
  // Obtener configuración pública de pricing
  async getConfig() {
    try {
      const response = await apiClients.pricing.get('/config');
      return response.data;
    } catch (error) {
      console.error('Error en getConfig:', error);
      throw new Error('No se puede conectar con el servidor. Las compras no están disponibles en este momento.');
    }
  },

  // Calcular precio (ejecutado en el backend)
  async calculatePrice(documentCount) {
    try {
      const response = await apiClients.pricing.post('/calculate', {
        document_count: documentCount
      });
      return response.data;
    } catch (error) {
      let errorMessage = 'Error al calcular precio';
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          errorMessage = error.response.data.detail.map(err => err.msg).join(', ');
        } else {
          errorMessage = error.response.data.detail;
        }
      } else if (error.message) {
        errorMessage = error.message;
      }
      console.error('Error en calculatePrice:', error);
      throw new Error(errorMessage);
    }
  },

  // Enviar comprobante Yape
  async sendYapePayment(formData) {
    try {
      // Crear una instancia de axios sin los interceptores que podrían interferir
      const token = localStorage.getItem('token');
      
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/v1/pricing/yape/submit`,
        formData,
        {
          headers: {
            'Authorization': token ? `Bearer ${token}` : undefined,
            // No especificar Content-Type para que axios configure automáticamente multipart/form-data
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Aprobar solicitud de cuota (admin)
  async approveQuotaRequest(paymentId) {
    try {
      const response = await apiClients.users.post('/admin/approve-payment', { payment_id: paymentId });
      return response.data;
    } catch (error) {
      let errorMessage = 'Error al aprobar la solicitud de cuota';
      if (error.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      } else if (error.message) {
        errorMessage = error.message;
      }
      throw new Error(errorMessage);
    }
  },

  // Rechazar solicitud de cuota (admin)
  async rejectQuotaRequest(paymentId) {
    try {
      const response = await apiClients.users.post('/admin/reject-payment', { payment_id: paymentId });
      return response.data;
    } catch (error) {
      let errorMessage = 'Error al rechazar la solicitud de cuota';
      if (error.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      } else if (error.message) {
        errorMessage = error.message;
      }
      throw new Error(errorMessage);
    }
  }
};
